import React, { Component } from "react";
import ReactDOM from "react-dom";
import { IDuplicatePdfPromptComponentProps } from "../types/props";
import "./duplicatePdfPromptComponent.scss";
class BrochureDuplicatePdfPromptComponent extends Component<IDuplicatePdfPromptComponentProps> {
  render() {
    const portal = ReactDOM.createPortal(
      <div
        className="duplicate-pdf-brochure-prompt"
        onClick={(event) => event.stopPropagation()}
      >
        <p>
          You have already made this selection. Please make another selection.
        </p>
        <div className="duplicate-pdf-brochure-prompt--actions">
          <button onClick={this.confirm} className="btn ampri-button-primary">
            Close
          </button>
        </div>
      </div>,
      document.getElementById("pdf-brochure-duplicate--modal")
    );
    return <>{portal}</>;
  }
  confirm = () => {
    this.props.confirm();
  };
}

export default BrochureDuplicatePdfPromptComponent;
